// extracted by mini-css-extract-plugin
export default {"tag":"roleTag_tag__vAYT4"};